/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_PriorityInputs */

const cs_field_priority = /** @type {(inputs: Field_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorita`)
};

const en_field_priority = /** @type {(inputs: Field_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Field_PriorityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_priority = /** @type {((inputs?: Field_PriorityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_PriorityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_priority(inputs)
	return cs_field_priority(inputs)
});